import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class SearchForm extends kr.Component {
    init() {
        this._input = document.querySelector('.jsSearchForm input[name="s"]');
        this._close = document.querySelector('.jsSearchForm .jsSearchFormClose');
        this.bind();
    }

    bind() {
        this.on('click', (target, event) => {
            event.preventDefault();
            HTMLClass.addClass(this.app.dom.$body, 'web__searchform--active');
            HTMLClass.removeClass(this.app.dom.$body, 'header__nav--opened');
            window.setTimeout(() => {
                this._input.focus();
                this._input.select();
            }, 100);
        });
        
        this._close.addEventListener('click', () => {
            HTMLClass.removeClass(this.app.dom.$body, 'web__searchform--active');
        }, true);
    }
}

kr.registerComponent('.jsSearchButton', {
    component: SearchForm
});